import { ComponentType, ReactNode } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';

export type ButtonProps = {
    external?: boolean;
    disabled?: boolean;
    showArrow?: boolean;
    variant?: 'primary' | 'highlight' | 'outlined';
    tag?: ComponentType | keyof JSX.IntrinsicElements;
    children?: ReactNode;
} & React.HTMLAttributes<HTMLOrSVGElement> &
    React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const Button: React.FC<ButtonProps> = ({
    href = undefined,
    external = false,
    disabled = false,
    showArrow = false,
    variant = 'highlight',
    tag: Wrapper = 'a',
    children,
    ...props
}) => {
    if (disabled) {
        props.onClick = () => false;
    }

    return (
        //@ts-ignore
        <Wrapper
            {...props}
            disabled={disabled}
            className={clsx(
                style.button,
                props.className,
                style[variant],
                showArrow && style.showArrow,
                disabled && style.disabled,
            )}
            href={href}
            {...(Wrapper === 'a' && external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
            <div className={style.text}>{children}</div>
        </Wrapper>
    );
};

export default Button;
